import type { QueueSettings, UpdateQueueSettings } from '@easyhelp/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError, apiRequest } from './client';

export const queueSettingsQueryKey = ['settings', 'queue'] as const;

/** `GET /settings/queue`: casella mittente, testi delle email e regole della coda. */
export function fetchQueueSettings(): Promise<QueueSettings> {
  return apiRequest<QueueSettings>('/settings/queue');
}

/** Impostazioni di coda correnti. */
export function useQueueSettings() {
  return useQuery({ queryKey: queueSettingsQueryKey, queryFn: fetchQueueSettings });
}

/** `PUT /settings/queue`: sostituisce il record; la risposta diventa il nuovo stato della query. */
export function useUpdateQueueSettings() {
  const queryClient = useQueryClient();
  return useMutation<QueueSettings, ApiError, UpdateQueueSettings>({
    mutationFn: (values) =>
      apiRequest<QueueSettings>('/settings/queue', { method: 'PUT', body: JSON.stringify(values) }),
    onSuccess: (updated) => queryClient.setQueryData(queueSettingsQueryKey, updated),
  });
}
